import React from 'react'
import { Meta } from '../../../components'

const MobileComponent = ({organization, occupation, email}) => {
  return (
    <div>
      <div className="w-3/4 ml-auto flex flex-wrap -mx-2 mb-4">
        {/* <div className="w-full mb-4">
          <Meta label="City" value={city}/>
        </div> */}
        <div className="w-full mb-4">
          {/* <Meta label="Organization" value={organization}/> */}
          <Meta label="Occupation" value={occupation}/>
        </div>
        <div className="w-full">
          <Meta label="Email" value={email}/>
        </div>
      </div>
    </div>
  )
}

const DesktopComponent = ({organization, occupation, email}) => {
  return (
    <div>
      <div className="flex flex-wrap -mx-4">
        {/* <div className="w-1/5 px-4">
          <Meta label="City" value={city}/>
        </div> */}
        <div className="w-1/5 px-4">
          {/* <Meta label="Organization" value={organization}/> */}
          <Meta label="Occupation" value={occupation}/>
        </div>
        <div className="w-1/5 px-4">
          <Meta label="Email" value={email}/>
        </div>
      </div>
    </div>
  )
}

const ProfileHeaderMetas = ({isMobile, occupation = '-', organization = '-', email = '-'}) => {
  const filteredOrganization = organization && organization !== null ? organization : '-'

  return isMobile ?
  <MobileComponent occupation={occupation} organization={filteredOrganization} email={email} />
  : <DesktopComponent occupation={occupation} organization={filteredOrganization} email={email} />
}

export { ProfileHeaderMetas }
